module.exports = function anonymous(it
) {
var out='<button class="';if(it.name){out+=' js-'+(it.name)+'-instance ';}out+=' btn btn-small ';if(it.cssClasses){out+=' '+(it.cssClasses)+' ';}out+='"> ';if(it.icon){out+='<i class="'+(it.icon)+'"></i>';}out+=' <span ';if(!it.label){out+=' rel="localize[action.'+(it.name)+']" ';}out+='>'+(it.label||it.name)+'</span></button>';return out;
}